"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.track = exports.initialize = void 0;
const Wait = require("./wait");
const SELLOUT_FACEBOOK_PIXEL_ID = '205397967210775';
function waitForPixel() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield Wait.forTrue(() => Boolean(window.fbq));
    });
}
/****************************************************************************************
  Initialization
****************************************************************************************/
function initialize(facebookPixelId) {
    try {
        injectPixel(SELLOUT_FACEBOOK_PIXEL_ID);
        if (facebookPixelId) {
            injectPixel(facebookPixelId);
        }
        else {
            console.log('Facebook Pixel not configured');
        }
    }
    catch (e) {
        console.error('Failed to inject Facebook Pixel');
        console.error(e);
    }
}
exports.initialize = initialize;
function injectPixel(facebookPixelId) {
    const headCode = `
    < !--Facebook Pixel Code-- >
    <script>
      !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod ?
        n.callMethod.apply(n, arguments) : n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${facebookPixelId}');
    fbq('track', 'PageView');
  </script>
    <noscript><img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=${facebookPixelId}&ev=PageView&noscript=1"
    /></noscript>
    <!--End Facebook Pixel Code-- >
  `;
    const headScript = document.createRange().createContextualFragment(headCode);
    document.head.prepend(headScript);
}
/****************************************************************************************
  Tracking
****************************************************************************************/
function track(type, action, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield waitForPixel();
            window.fbq(type, action, params);
        }
        catch (e) {
            console.error('Facebook Pixel failed to track event');
        }
    });
}
exports.track = track;
//# sourceMappingURL=FacebookUtil.js.map